import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { IGetEnvironmentDetails } from "../interfaces/get-environments-details";
import { IEnvironmentDetails } from "./../interfaces/environment-details";

@Injectable({
  providedIn: "root",
})

export class EnvironmentDetailsService implements IGetEnvironmentDetails {
  constructor() { }


  getEnvironmentsDetails(
    subscriptionId: string
  ): Observable<IEnvironmentDetails[]> {
    return of([
      {
        name: "ENV-2",
        type: "Production",
        region: "US (East US)",
        serverProfile: "ENT-3",
        os: "Windows",
        servers: "10.0.0.1(A), 10.0.0.2(M), 10.0.0.3(M)",
      },
      {
        name: "ENV-3",
        type: "Production",
        region: "(Middle-East) Qatar-Central",
        serverProfile: "ENT-4",
        os: "Linux",
        servers: "10.0.0.1(A), 10.0.0.2(M), 10.0.0.3(M)",
      },
    ]).pipe(catchError(this.handleError));
  }

  getEnvironmentInfo(envName: string): Observable<IEnvironmentDetails> {
    return of({
      name: "ENV-2",
      type: "Production",
      region: "US (East US)",
      serverProfile: "ENT-3 (4GB, 2VCPUs)",
      os: "Windows",
      servers: "10.0.0.1(A)",
    }).pipe(catchError(this.handleError));
  }

  createEnvPeering(currentEnvName: string, selectedEnvDetails: object): Observable<any> {    
    return of(true);
  }

  handleError(error: HttpErrorResponse): Observable<any> {
    return throwError(error.error);
  }
}

